function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const PagedList = require('../entities/paged-list');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Address = require('../entities/address');

const LegacyAddressesRepo = require('./addresses-legacy-repo');

const {
  strinct,
  geoPoint
} = require('../utils/serialize');

const createFields = ['id', 'suite', 'streetAddress', 'street', 'city', 'state', 'country', 'osmId', 'centre', 'postalcode'];
const fields = ['id', 'suite', 'streetAddress', 'street', 'city', 'state', 'country', 'osmUid'];
const searchFields = ['id', 'osmUid', 'googlePlaceId', 'suite', 'building', 'streetAddress', 'street', 'postalcode', 'locality', 'neighbourhood', 'city', 'county', 'state', 'region', 'country', 'centre', 'timezone'];

const parse = json => new Address(json);

const serialize = address => ({
  country: strinct(address.country),
  // required
  centre: geoPoint([address.centre.long, address.centre.lat]),
  // required
  type: address.type,
  city: address.city,
  // required
  state: strinct(address.state),
  // required
  osmId: strinct(address.osmId),
  googlePlaceId: strinct(address.googlePlaceId),
  suite: strinct(address.suite),
  building: strinct(address.building),
  streetAddress: strinct(address.streetAddress),
  street: strinct(address.street),
  postalcode: strinct(address.postalcode),
  locality: strinct(address.locality),
  neighbourhood: strinct(address.neighbourhood),
  county: strinct(address.county),
  region: strinct(address.region)
});

class AddressRepo {
  constructor(client, id) {
    this.client = client;
    this.id = id;
  }

  details()
  /*: Promise<Address>*/
  {
    const req = new this.client.Request(`/addresses/${this.id}`, undefined, fields);

    req.parse = json => new Address(json);

    return this.client.get(req);
  }

}

class AddressesRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;

    this.for = (id
    /*: addressId*/
    ) => new AddressRepo(client, id);

    this.legacy = new LegacyAddressesRepo(this.client);
  }

  search({
    /*: {
        addressId?: string,
        building?: string,
        street?: string,
        neighbourhood?: string,
        city: ? string,
        county?: string,
        state?: string,
        country?: string,
        query?: string,
        limit?: string,
        offset?: string
      }*/

    addressId,
    building,
    street,
    neighbourhood,
    city,
    county,
    state,
    country,
    query,
    limit,
    offset
  }) {
    const params = {
      addressId,
      building,
      street,
      neighbourhood,
      city,
      county,
      state,
      country,
      q: query,
      limit,
      offset
    };
    const req = new this.client.Request('/addresses/search', params, searchFields);
    req.parse = parse;
    return this.client.get(req);
  }

  create(address
  /*: Object*/
  )
  /*: Promise<Address>*/
  {
    const _this = this;

    return _call(function () {
      const path = '/addresses';
      const req = new _this.client.Request(path, address, createFields);
      req.serialize = serialize;
      req.parse = parse;
      return _await(_this.client.post(req));
    });
  } // LEGACY API


  details(id
  /*: string*/
  )
  /*: Promise<Address>*/
  {
    return this.for(id).details();
  }

  discover(...args)
  /*: Promise<PagedList<Address>>*/
  {
    return this.legacy.discover(...args);
  }

  persist(...args) {
    return this.legacy.persist(...args);
  }

  sync(...args) {
    return this.legacy.sync(...args);
  }

  generateToken(...args) {
    return this.legacy.generateToken(...args);
  }

}

module.exports = AddressesRepo;